export default {"src":"/_next/static/media/installation-service.cb6a5d61.svg","height":100,"width":100};